import axios from "axios";
import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const botList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/business/@bots", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
// export const changeStatus = async ({ accessToken, username, status }) => {

//   const newStatus = status.status;

//   console.log(newStatus, "sta");
//   try {
//     const response = await axiosInstance.patch(
//       "/business/edit",
//       { username, status: newStatus },
//       {
//         // baseURL:"http://194.60.231.54/v1",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           //   "Access-Control-Request-Method":"PATCH"
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     if (error.response) {
//       const status = error.response.status;
//       const serverError = error.response.data?.error;
//       if (status === 402) {
//         if (serverError.startsWith("nsufficient tokens, required")) {
//           toast.error("توکن  بات مورد نظر به اتمام رسیده است.امکان  تغییر وضعیت وجود ندارد.");
//         }
//       } else if (status === 403) {
//         console.warn(
//           "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
//         );
//         window.location.href = "/login";
//         return;
//       } throw {
//         statusCode: status,
//         message:
//           error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
//       };
//     } else {
//       throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
//     }

//   }
// };
export const changeStatus = async ({ accessToken, username, status }) => {
  const newStatus = status.status;

  try {
    const response = await axiosInstance.patch(
      "/business/edit",
      { username, status: newStatus },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const statusCode = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      console.log(statusCode, serverError, "serverError")
      if (statusCode === 402) {
        if (serverError?.startsWith("Insufficient tokens")) {
          toast.error("توکن بات مورد نظر به اتمام رسیده است. امکان تغییر وضعیت وجود ندارد.");
          return;
        }
      } else if (statusCode === 403) {
        console.warn("خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود.");
        window.location.href = "/login";
        return;
      }

      throw {
        statusCode: statusCode,
        message: error.response.data?.message || "خطای ناشناخته هنگام تغییر وضعیت",
      };
      */
    }
    //  else {
    //   throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    // }
  }
};

export const adminDashboardInfo = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/admin/@me", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const personalPlanRequest = async (accessToken) => {
  try {
    const response = await axiosInstance.get(
      "/admin/feedbacks",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const statusCode = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
    }
  }
}